import { gql } from "@grandvisionhq/graphql";
const eyePrescription = gql`
  fragment EyePrescriptionFragment on SingleEyePrescription {
    baseCurve
    diameter
    power
    axis
    cylinder
    addition
    pupillaryDistance
  }
`;
export {
  eyePrescription
};
//# sourceMappingURL=eye-prescription.js.map
